export enum urlApp {
  DomainName = 'https://daiichi.mobile',
  // // test -------------------------------------------
  APIURL = 'https://apis.fplatform.fincorp.vn/web/v1/', //test/dev//
  eventLink = 'https://daiichi.dev.techland.link/',
  // // // //uat -------------------------------------------
  // APIURL = 'https://oapis.fplatform-uat.fincorp.vn/web/v1/', //main//
  // eventLink = 'https://itrust-uat.dfvn.com.vn/', //uat
  // live -------------------------------------------
  // APIURL = 'https://oapis.fplatform-live.fincorp.vn/web/v1/', //live//
  // eventLink = 'https://itrust.dfvn.com.vn/', //live
}
